import { CidadaoAtendimentoSelectFieldModel } from 'components/form'
import { formatISO } from 'date-fns'
import { Cidadao } from 'graphql/types.generated'

import {
  AgendamentoConsultaCompartilhadaModel,
  AgendamentoConsultaModel,
  AgendamentoEdicaoModel,
  CidadaoAgendamentoConsultaCompartilhada,
  CidadaoCadastroAgendamentoQueryModel,
} from '../model-agenda'

export function createInitialValuesAgendamentoConsulta(
  agendamentoEdicao: AgendamentoEdicaoModel,
  cidadaoQueryModel: CidadaoCadastroAgendamentoQueryModel,
  horarioInicial: Instant,
  horarioFinal: Instant | null | undefined
): Partial<AgendamentoConsultaModel> {
  return agendamentoEdicao
    ? createInitialValuesEdicaoConsulta(agendamentoEdicao)
    : createInitialValuesCadastroConsulta(cidadaoQueryModel, horarioInicial, horarioFinal)
}

export function createInitialValuesAgendamentoConsultaCompartilhada(
  agendamentoEdicao: AgendamentoEdicaoModel,
  cidadaoQueryModel: CidadaoCadastroAgendamentoQueryModel,
  horarioInicial: Instant,
  horarioFinal: Instant | null | undefined
): Partial<AgendamentoConsultaCompartilhadaModel> {
  return agendamentoEdicao
    ? createInitialValuesEdicaoConsultaCompartilhada(agendamentoEdicao)
    : createInitialValuesCadastroConsultaCompartilhada(cidadaoQueryModel, horarioInicial, horarioFinal)
}

function createInitialValuesEdicaoConsulta(
  agendamentoEdicao: AgendamentoEdicaoModel
): Partial<AgendamentoConsultaModel> {
  const { telefoneCelular, email } = agendamentoEdicao.cidadao?.contato || {}
  return {
    ...createInitialValuesEdicaoAgendamento(agendamentoEdicao),
    cidadao: agendamentoEdicao.cidadao,
    contatoCidadao: {
      telefoneCelular,
      email,
      enviarEmail: false,
    },
    localAtendimento: agendamentoEdicao.localAtendimento,
    imprimirAgendamento: false,
  }
}

function createInitialValuesCadastroConsulta(
  cidadaoQueryModel: CidadaoCadastroAgendamentoQueryModel,
  horarioInicial: Instant,
  horarioFinal: Instant | null | undefined
): Partial<AgendamentoConsultaModel> {
  return {
    ...createInitialValuesCadastroAgendamento(horarioInicial, horarioFinal),
    cidadao: createInitialValuesCidadaoCadastroConsulta(cidadaoQueryModel),
    imprimirAgendamento: false,
  }
}

function createInitialValuesEdicaoConsultaCompartilhada(
  agendamentoEdicao: AgendamentoEdicaoModel
): Partial<AgendamentoConsultaCompartilhadaModel> {
  const { telefoneCelular, email } = agendamentoEdicao.cidadao?.contato || {}

  return {
    ...createInitialValuesEdicaoAgendamento(agendamentoEdicao),
    lotacaoConvidada: agendamentoEdicao.lotacaoConvidada,
    cidadaoParticipante: agendamentoEdicao.cidadao
      ? {
          cidadao: agendamentoEdicao.cidadao,
          contato: {
            telefoneCelular,
            email,
            enviarEmail: false,
          },
        }
      : null,
  }
}

function createInitialValuesCadastroConsultaCompartilhada(
  cidadaoQueryModel: CidadaoCadastroAgendamentoQueryModel,
  horarioInicial: Instant,
  horarioFinal: Instant | null | undefined
): Partial<AgendamentoConsultaCompartilhadaModel> {
  return {
    ...createInitialValuesCadastroAgendamento(horarioInicial, horarioFinal),
    cidadaoParticipante: createInitialValuesCidadaoCadastroConsultaCompartilhada(cidadaoQueryModel),
  }
}

type CommonInitialValuesAgendamentoConsulta = Partial<AgendamentoConsultaModel> &
  Partial<AgendamentoConsultaCompartilhadaModel>

function createInitialValuesEdicaoAgendamento(
  agendamentoEdicao: AgendamentoEdicaoModel
): CommonInitialValuesAgendamentoConsulta {
  return {
    horario: agendamentoEdicao.horario,
    data: formatISO(agendamentoEdicao.horario.inicial),
    observacoes: agendamentoEdicao.observacoes,
  }
}

function createInitialValuesCadastroAgendamento(
  horarioInicial: Instant,
  horarioFinal: Instant | null | undefined
): CommonInitialValuesAgendamentoConsulta {
  return {
    horario: { inicial: new Date(horarioInicial), final: horarioFinal ? new Date(horarioFinal) : undefined },
    data: horarioInicial ? formatISO(horarioInicial) : null,
  }
}

function createInitialValuesCidadaoCadastroConsultaCompartilhada(
  cidadaoQueryModel: CidadaoCadastroAgendamentoQueryModel
): CidadaoAgendamentoConsultaCompartilhada {
  const { telefoneCelular, email, faleceu, ...rest } = cidadaoQueryModel ?? ({} as Cidadao)

  return rest.id && !faleceu
    ? {
        cidadao: {
          ...rest,
          contato: {
            telefoneCelular,
            email,
          },
        },
        contato: {
          telefoneCelular,
          email,
          enviarEmail: false,
        },
      }
    : null
}

function createInitialValuesCidadaoCadastroConsulta(
  cidadaoQueryModel: CidadaoCadastroAgendamentoQueryModel
): CidadaoAtendimentoSelectFieldModel {
  const { telefoneCelular, email, faleceu, ...rest } = cidadaoQueryModel ?? ({} as Cidadao)

  return rest.id && !faleceu
    ? {
        ...rest,
        contato: {
          telefoneCelular,
          email,
        },
      }
    : null
}
